import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchDrivers(ctx, queryParams) {

            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Driver/search?Search=${queryParams.q}&Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchDriver(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                .get(`/api/v1/driver?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addDriver(ctx, driverData) {
            return new Promise((resolve, reject) => {

                let driver = driverData.driverData
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/driver', driver)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateDriver(ctx, driverData) {
            return new Promise((resolve, reject) => {

                let driver = driverData.driverData
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .put('/api/v1/driver', driver)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteDriver(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .delete(`/api/v1/driver?Id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchCustomers(ctx, queryParams) {

            return new Promise((resolve, reject) => {

                axios
                    //.get('/apps/asset/assets', { params: queryParams })
                    .get(`/api/v1/Customer/search?Search=${queryParams.q}&Page=1&PerPage=5`)
                    //.get(`/api/v1/Asset/search?Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchCustomer(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/user/users/${id}`)
                    .get(`/api/v1/Customer?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addDriverAttribution(ctx, driverData) {
           
            return new Promise((resolve, reject) => {

                axios
                    .post('/api/v1/Driver/createdriverattribution', driverData.driverData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateDriverAttribution(ctx, driverData) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/v1/Driver/updatedriverattribution', driverData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        getDriverAttribution(ctx, driverId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Driver/getdriverattribution?id=${driverId}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        searchDriverAttributions(ctx, {start, end, page, perPage, driverId, assetId}) {
            return new Promise((resolve, reject) => {
                // 1. Cria um objeto para os parâmetros da requisição.
                const params = {
                    Start: start,
                    End: end,
                    Page: page,
                    PerPage: perPage,
                };

                // 2. Adiciona os IDs ao objeto de parâmetros APENAS se eles não forem nulos.
                //    (Assumindo que a API espera os parâmetros como 'DriverId' e 'AssetId')
                if (driverId) {
                    params.DriverId = driverId;
                }
                if (assetId) {
                    params.AssetId = assetId;
                }

                // 3. Passa o objeto 'params' para o axios. Ele montará a URL final.
                //    Ex: /...searchdriverattribution?Start=...&End=...&DriverId=123
                axios
                    .get('/api/v1/Driver/searchdriverattribution', { params })
                    .then(response => resolve(response.data))
                    .catch(error => reject(error));
            });
        }
        
    },
}